// @flow
import { createAction } from 'redux-actions';
import { type OrderedMap } from 'immutable';
import { type Observation, type ModerationState } from 'models';

export const addItem = createAction(
  'CORE_DATA_ADD_ITEM',
  (payload: {
    data: GetContentResponse,
    observationsMap: OrderedMap<string, Observation>,
  }) => payload
);

export const addItems = createAction(
  'CORE_DATA_ADD_ITEMS',
  (payload: {
    data: GetContentCollectionResponse,
    observationsMap: OrderedMap<string, Observation>,
  }) => payload
);

const observationsPayloadCreator = (payload: ModerationState) => payload;
type PublicationDecisionMeta = {
  clientId: Id,
  ugcClientId: Id,
  ugctype: UgcType,
};

export const updateObservations = createAction(
  'UPDATE_OBSERVATIONS',
  (payload: ModerationState) => payload,
  // $FlowFixMe
  (_, meta: PublicationDecisionMeta) => meta
);

export const updateSiteStatus = createAction(
  '@coreData/update-site-status',
  (payload: { moderationState: ModerationState, desiredPublished: boolean }) =>
    payload,
  (_, meta: PublicationDecisionMeta) => meta
);

export const receiveSiteStatusUpdate = createAction(
  '@coreData/receive-site-status',
  // $FlowFixMe
  (payload: boolean) => payload,
  (_, ugcId) => ugcId
);

export const commitSiteStatusUpdate = createAction(
  '@coreData/commit-site-status',
  (payload: boolean) => payload,
  (_, meta: Id) => meta
);

export const commitObservationsUpdate = createAction(
  'COMMIT_OBSERVATION_UPDATE',
  observationsPayloadCreator,
  (_, clientId: Id) => clientId
);

export const requestObservationsUpdate = createAction(
  'REQUEST_OBSERVATIONS_UPDATE',
  (payload: ModerationState, _: Id) => payload,
  (_: ModerationState, context: Id) => context
);

export const receiveObservationsUpdate = createAction(
  'RECEIVE_OBSERVATIONS_UPDATE',
  (payload: UgcId) => payload,
  (_, ugcId?: UgcId) => ugcId
);

type AddResponsePayload = {
  parent_ugc_id: UgcId,
  subject_id: UgcId,
  catalog_id: UgcId,
  text: string,
  ugc_type: ResponseUgcType,
};

export const requestAddResponse = createAction(
  'ADD_RESPONSE_REQUEST',
  (payload: AddResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

export const receiveAddResponse = createAction(
  'ADD_RESPONSE',
  (payload: AddResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

type DeleteResponsePayload = {
  ugc_id: UgcId,
  client_id: Id,
};

export const requestDeleteResponse = createAction(
  'DELETE_RESPONSE_REQUEST',
  (payload: DeleteResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

export const receiveDeleteResponse = createAction(
  'DELETE_RESPONSE',
  (payload: DeleteResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

type EditResponsePayload = AddResponsePayload & {
  ugc_id: number,
};

export const requestEditResponse = createAction(
  'EDIT_RESPONSE_REQUEST',
  (payload: EditResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

export const receiveEditResponse = createAction(
  'EDIT_RESPONSE',
  // $FlowFixMe Error: redux-actions requires another parameter
  (payload: EditResponsePayload) => payload,
  (_, parent_ugc_id) => parent_ugc_id
);

export const updateUgc = createAction(
  '@ugc/update-ugc',
  (payload: { [string]: * } | (Ugc => Ugc)) => payload,
  (_, ugcId: Id) => ugcId
);

export const removeUgc = createAction(
  '@ugc/remove-ugc',
  (payload: UgcId) => payload
);



// WEBPACK FOOTER //
// ./src/ducks/coreDataActions.js